import {useEffect, useRef, useState} from 'react';

import {useDebounce, useMeasure} from 'react-use';
import * as PostMessage from 'ui/utils/postMessages';

import {useWindowMutation} from './useWindowMutation';

const ResizeObserver = require('resize-observer-polyfill').default;
if (!window.ResizeObserver) {
    window.ResizeObserver = ResizeObserver;
}

const eventListener = () => {
    PostMessage.sendUnload();
};

const useHeightpostMessage = () => {
    const [ref, {height}] = useMeasure<HTMLDivElement>();
    const [windowHeight, setWindowHeight] = useState(0);
    const lastSendedHeight = useRef<number>();

    useWindowMutation(
        {
            attributes: true,
            childList: true,
            subtree: true,
        },
        () => {
            const popups = document.querySelector('.yc-popup');

            setWindowHeight(
                popups
                    ? Math.max(
                          document.documentElement.scrollHeight,
                          document.body.scrollHeight,
                          document.body.offsetHeight,
                          (popups?.scrollHeight ?? 0) + 20,
                      )
                    : 0,
            );
        },
    );

    useEffect(() => {
        PostMessage.sendLoad();
        window.addEventListener('beforeunload', eventListener);
        return () => {
            window.removeEventListener('beforeunload', eventListener);
        };
    }, []);

    useDebounce(
        () => {
            const nextHeight = Math.max(windowHeight, height);
            if (!height || nextHeight === lastSendedHeight.current) {
                return;
            }
            lastSendedHeight.current = nextHeight;
            PostMessage.sendHeight(nextHeight);
        },
        200,
        [height, windowHeight],
    );

    return ref;
};

export default useHeightpostMessage;
